var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.785156 5.36452H5.86452V0.285156H0.785156V5.36452ZM2.055 1.555H4.59468V4.09468H2.055V1.555ZM0.785156 11.7137H5.86452V6.63436H0.785156V11.7137ZM2.055 7.9042H4.59468V10.4439H2.055V7.9042ZM7.13436 0.285156V5.36452H12.2137V0.285156H7.13436ZM10.9439 4.09468H8.4042V1.555H10.9439V4.09468ZM7.14071 6.63436H8.41055V7.9042H7.14071V6.63436ZM8.41055 7.9042H9.68039V9.17405H8.41055V7.9042ZM7.14071 9.17405H8.41055V10.4439H7.14071V9.17405ZM9.68039 9.17405H10.9502V10.4439H9.68039V9.17405ZM10.9502 10.4439H12.2201V11.7137H10.9502V10.4439ZM8.41055 10.4439H9.68039V11.7137H8.41055V10.4439ZM9.68039 6.63436H10.9502V7.9042H9.68039V6.63436ZM10.9502 7.9042H12.2201V9.17405H10.9502V7.9042Z",
    fill: "url(#paint0_linear_4847_63916)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63916",
    x1: 0.785156,
    y1: 0.285156,
    x2: 12.4532,
    y2: 0.52835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsDashboard);
export default __webpack_public_path__ + "static/media/cs-dashboard.4ad300e58c753f13056b8afd4b4ef4e5.svg";
export { ForwardRef as ReactComponent };